import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-welcome-column',
  templateUrl: './welcome-column.component.html',
  styleUrls: ['./welcome-column.component.scss']
})
export class WelcomeColumnComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
